// src/services/walletPrivacyService.js
//
// Per-user UI preference for masking wallet addresses in the Wallets
// tab. Lives in Firestore so the preference syncs across devices.
//
// Use case: Gven (and other students who record content) want to enable
// privacy mode once and have it stick — no risk of forgetting to flip
// it back on after a refresh, no need to re-flip it on a different
// browser before screen-sharing.
//
// Stored at:
//   users/{uid}/settings/walletPrivacy
//
// Doc shape:
//   { hideAddresses: boolean, updatedAt: Timestamp }

import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../authentication/firebase-config";

const DEFAULT = Object.freeze({
  hideAddresses: false,
});

export async function fetchWalletPrivacy(uid) {
  if (!uid) return { ...DEFAULT };
  try {
    const snap = await getDoc(
      doc(db, "users", uid, "settings", "walletPrivacy")
    );
    if (!snap.exists()) return { ...DEFAULT };
    return { ...DEFAULT, ...snap.data() };
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("[walletPrivacyService] read failed:", err.message);
    return { ...DEFAULT };
  }
}

export async function writeWalletPrivacy(uid, prefs) {
  if (!uid) return;
  try {
    await setDoc(
      doc(db, "users", uid, "settings", "walletPrivacy"),
      { ...prefs, updatedAt: serverTimestamp() },
      { merge: true }
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("[walletPrivacyService] write failed:", err.message);
  }
}
